/*
 * Mobile nav footer — open/close behaviour for the native bottom nav bar
 * (replaces ConvertCart's zepto implementation). Vanilla JS, no dependencies.
 * Tapping a tab toggles its bottom-sheet popup; sub-toggles slide in a submenu;
 * back/close/overlay/ESC dismiss. See assets/mobile-nav-footer.css.
 */
(function () {
  'use strict';

  var root = document.getElementById('aro-mnf');
  if (!root) return;

  var overlay = root.querySelector('[data-mnf-overlay]');
  var panels = {};
  root.querySelectorAll('[data-mnf-panel]').forEach(function (p) {
    panels[p.getAttribute('data-mnf-panel')] = p;
  });

  function closeSubmenus() {
    root.querySelectorAll('.aro-mnf__submenu').forEach(function (s) {
      s.classList.remove('is-active');
    });
  }

  function closeAll() {
    Object.keys(panels).forEach(function (k) {
      panels[k].classList.remove('is-active');
      panels[k].setAttribute('aria-hidden', 'true');
    });
    closeSubmenus();
    root.querySelectorAll('.aro-mnf__item').forEach(function (it) {
      it.classList.remove('is-active');
    });
    root.querySelectorAll('[data-mnf-popup]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    if (overlay) overlay.classList.remove('is-active');
    document.body.classList.remove('aro-mnf-open');
  }

  function openPopup(type) {
    closeAll();
    var p = panels[type];
    if (!p) return;
    p.classList.add('is-active');
    p.setAttribute('aria-hidden', 'false');
    var btn = root.querySelector('[data-mnf-popup="' + type + '"]');
    if (btn) {
      btn.setAttribute('aria-expanded', 'true');
      var item = btn.closest('.aro-mnf__item');
      if (item) item.classList.add('is-active');
    }
    if (overlay) overlay.classList.add('is-active');
    document.body.classList.add('aro-mnf-open');
  }

  // Tab tap — toggle the matching popup.
  root.querySelectorAll('[data-mnf-popup]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var type = btn.getAttribute('data-mnf-popup');
      var isOpen = panels[type] && panels[type].classList.contains('is-active');
      closeAll();
      if (!isOpen) openPopup(type);
    });
  });

  // Sub-menu open.
  root.querySelectorAll('[data-mnf-sub]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var key = btn.getAttribute('data-mnf-sub');
      var panel = root.querySelector('[data-mnf-submenu="' + key + '"]');
      closeSubmenus();
      if (panel) panel.classList.add('is-active');
    });
  });

  // Back button (within a submenu).
  root.querySelectorAll('[data-mnf-back]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var sub = btn.closest('.aro-mnf__submenu');
      if (sub) sub.classList.remove('is-active');
    });
  });

  // Close buttons + overlay + ESC.
  root.querySelectorAll('[data-mnf-close]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      closeAll();
    });
  });
  if (overlay) overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  // Highlight Home on the homepage.
  var path = window.location.pathname;
  if (path === '/' || path === '') {
    var home = root.querySelector('[data-mnf-home]');
    if (home) {
      var hi = home.closest('.aro-mnf__item');
      if (hi) hi.classList.add('is-active');
    }
  }
})();
